export default __webpack_public_path__ + "static/media/116.c5ece5d9.jpg";